import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LogData, LogResponse } from 'src/app/models/basics/api.response';
import {environment as env } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}
  login(user: LogData): Observable<LogResponse>{
    return this.http.post<LogResponse>(`${env.apiUrl}/auth/login`,user);
  }

  refreshToken(rto: string): Observable<LogResponse>{
    return this.http.post<LogResponse>(`${env.apiUrl}/auth/refresh`, { rto });
  }
}
